import Home from '../landing-page';

export default Home;
